"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createGetScootersByPosition = createGetScootersByPosition;
exports.isBatteryScooter = isBatteryScooter;
exports.isBatteryLevelScooter = isBatteryLevelScooter;

var _http = require("../http");

var _types = require("./types");

var _config = require("../config");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var ALL_OPERATORS = Object.values(_types.ScooterOperator);

function createGetScootersByPosition(argConfig) {
  var config = (0, _config.getServiceConfig)(argConfig);

  var _getScootersHost = (0, _config.getScootersHost)(config),
      host = _getScootersHost.host,
      headers = _getScootersHost.headers;

  return /*#__PURE__*/function () {
    var _getScootersByPosition = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
      var lat, lon, _params$distance, range, _params$limit, max, _params$operators, operators, data;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              lat = params.latitude, lon = params.longitude, _params$distance = params.distance, range = _params$distance === void 0 ? 200 : _params$distance, _params$limit = params.limit, max = _params$limit === void 0 ? 20 : _params$limit, _params$operators = params.operators, operators = _params$operators === void 0 ? ALL_OPERATORS : _params$operators;

              if (operators === null || operators === void 0 ? void 0 : operators.length) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", []);

            case 3:
              _context.next = 5;
              return (0, _http.get)(host, {
                lat: lat,
                lon: lon,
                range: range,
                max: max,
                operators: operators.join(',')
              }, headers);

            case 5:
              data = _context.sent;
              return _context.abrupt("return", data || []);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function getScootersByPosition(_x) {
      return _getScootersByPosition.apply(this, arguments);
    }

    return getScootersByPosition;
  }();
}

function isBatteryScooter(scooter) {
  return 'battery' in scooter;
}

function isBatteryLevelScooter(scooter) {
  return 'batteryLevel' in scooter;
}